import { Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { controlChanges } from '../../forms/control-changes';

const MESSAGES: Record<string, string> = {
  required: 'errors.fieldIsRequired',
  email: 'errors.emailIsIncorrect',
  phoneInvalid: 'errors.phoneInvalid',
  nonBusinessEmail: 'errors.nonBusinessEmail',
  minlength: 'errors.errorMinimalLengthIs',
  maxlength: 'errors.thisIsToLong',
  pattern: 'errors.thisUrlIsIncorrect',
  domainIncorrect: 'errors.thisUrlIsIncorrect',
  domainNotAviable: 'errors.thisUrlIsNotAviable',
  noDomainForEmailError: 'errors.noDomainForEmailError',
  subdomainInvalid: 'errors.subdomainInvalid',
  incorrectUrl: 'This url is incorrect',
  domainExist: '', // vc-input shows its own line for a taken sales url
};

/** The first error of a touched, invalid control, as a translated line. */
@Component({
  selector: 'app-error-displayer',
  imports: [TranslatePipe],
  templateUrl: './error-displayer.html',
  styleUrl: './error-displayer.scss',
})
export class ErrorDisplayer {
  readonly control = input.required<AbstractControl>();
  readonly maxLengthMessage = input<string>();
  private readonly changes = controlChanges(this.control);

  protected message(): string | null {
    this.changes();
    const control = this.control();
    const code = Object.keys(control.errors ?? {})[0];
    if (!control.touched || !code) {
      return null;
    }
    if (code === 'maxlength' && this.maxLengthMessage()) {
      return this.maxLengthMessage() ?? null;
    }
    return (code in MESSAGES ? MESSAGES[code] : 'errors.fieldHasError') || null;
  }
}
